import useDialogsStore from './store';

export default {
  plugin: {
    install(Vue) {
      /* eslint-disable no-param-reassign */
      function addDialog(instance, {
        message, title, type, intent, buttons, callback,
      }) {
        let cancelLabel = instance.$t('common.cancel');
        let confirmLabel = instance.$t('common.continue');
        if (intent === 'confirm') {
          if (buttons && buttons.length === 2) {
            [cancelLabel, confirmLabel] = buttons;
          }
        } else {
          cancelLabel = undefined;
          confirmLabel = instance.$t('common.ok');
          if (buttons && buttons.length === 1) {
            [confirmLabel] = buttons;
          }
        }

        useDialogsStore().addDialog({
          intent,
          message,
          type: type || 'danger',
          confirmLabel,
          cancelLabel,
          title,
          callback,
        });
      }

      Vue.prototype.$clyConfirm = function (payload) {
        addDialog(this, { ...payload, intent: 'confirm' });
      };

      Vue.prototype.$clyAlert = function (payload) {
        addDialog(this, { ...payload, intent: 'message' });
      };
      /* eslint-enable no-param-reassign */
    },
  },
  hasFormDialogsMixin(n) {
    let names = n;
    if (!Array.isArray(names)) {
      names = [names];
    }

    return {
      data() {
        return {
          formDialogs: names.reduce((acc, val) => {
            acc[val] = {
              name: val,
              isOpened: false,
              initialEditedObject: {},
            };

            acc[val].closeFn = function () {
              acc[val].isOpened = false;
            };

            return acc;
          }, {}),
        };
      },
      methods: {
        openFormDialog(name, initialEditedObject) {
          if (this.formDialogs[name].isOpened) {
            return;
          }
          this.loadFormDialog(name, initialEditedObject);
          this.formDialogs[name].isOpened = true;
        },
        loadFormDialog(name, initialEditedObject) {
          this.formDialogs[name].initialEditedObject = initialEditedObject || {};
        },
        closeFormDialog(name) {
          this.formDialogs[name].isOpened = false;
        },
      },
    };
  },
};
